import { gatewayService } from "@/services";
export default {
  data() {
    return {
      activationModal: false,
      submitLoading: {},
      gatewayId: "",
      serialNumber: "",
      changeStatusModal: false,
      changeStatusDescription: "",
      actionStatus: "",
      gatewayType: "",
      actionModalText: "",
      rules: [
        v =>
          !!v || this.$t("panel.posManagementPage.changeStatusModal.notEmpty")
      ]
    };
  },
  methods: {
    openActivationModal(item) {
      this.gatewayId = item.id;
      if (item.gatewayType === "WEB") {
        this.changeStatus("active");
      } else {
        this.activationModal = true;
      }
    },
    openChangeStatusModal(gatewayId, actionStatus, gatewayType) {
      this.gatewayId = gatewayId;
      this.changeStatusModal = true;
      this.actionStatus = actionStatus;
      this.actionModalText =
        actionStatus === "SUSPENDED" ? "suspend" : "deactivate";
      this.gatewayType = gatewayType;
    },
    closeActiveModal() {
      this.gatewayId = "";
      this.activationModal = false;
    },
    closeChangeStatusModal() {
      this.gatewayId = "";
      this.changeStatusModal = false;
    },
    activatePos() {
      this.submitLoading[this.gatewayId] = true;
      let model = {
        gatewayId: this.gatewayId,
        serialNumber: this.serialNumber
      };
      gatewayService
        .activePos(model)
        .then(res => {
          this.$toast.success(res.data.message);
          this.filtersSubmission(true);
          this.$refs.form.reset();
          this.activationModal = false;
        })
        .finally(() => {
          this.submitLoading[this.gatewayId] = false;
        });
    },
    changeStatus(Status = "notActive") {
      let model = {};
      if (Status === "active") {
        model = {
          gatewayId: this.gatewayId,
          gatewayStatus: "ACTIVE"
        };
      } else {
        if (!this.$refs.changeStatus.validate()) {
          return;
        }
        model = {
          gatewayId: this.gatewayId,
          description: this.changeStatusDescription,
          gatewayStatus: this.actionStatus
        };
      }
      this.submitLoading[this.gatewayId] = true;
      gatewayService
        .changeStatus(model)
        .then(res => {
          this.$toast.success(res.data.message);
          this.filtersSubmission(true);
          this.$refs.changeStatus.reset();
          this.changeStatusModal = false;
        })
        .finally(() => {
          this.submitLoading[this.gatewayId] = false;
        });
    }
  }
};
